import * as React from "react";
import { Context } from "./_context";
export const PushIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.707 11.293a1 1 0 0 1 0 1.414l-5 5-1.414-1.414L20.586 12l-4.293-4.293 1.414-1.414 5 5Z", fill: "currentColor" }));
  return iconset[size];
};
PushIcon.iconId = "UnSbnk";
